export const firebaseConfig = {
    apiKey: "AIzaSyBjhOrQFNOL3mm5MPyJ1VoCLrSFQjFwhYc",
    authDomain: "titans-people.firebaseapp.com",
    databaseURL: "https://titans-people.firebaseio.com",
    projectId: "titans-people",
    storageBucket: "",
    messagingSenderId: "457875431296",
    appId: "1:457875431296:web:5f5fc761c81fed61"
};
